module.exports = __webpack_public_path__ + "static/media/smartix-logo.ded94b48.png";